//NOTE: styling can be manipulated from App.scss

function Title(props) {
    return <h2>{props.content}</h2>
}

export default Title;